import {
  ResponsiveImage,
  ResponsiveImageProps,
} from '@/components/ResponsiveImage'

export interface ImageModuleProps {
  image: ResponsiveImageProps
  heroImage?: boolean
}

export const ImageModule: React.FC<ImageModuleProps> = ({
  image,
  heroImage,
}) => {
  // 90% of the image modules aren't used as a hero section.
  // If the value in Contentful is undefined, it means that it should be lazy-loaded.
  const lazyLoadingDisable = !!heroImage

  return <ResponsiveImage {...image} lazyLoading={!lazyLoadingDisable} />
}
